// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"69097b1c","99":"8509c9f1","146":"cb00ed64","175":"09bd5477","204":"e34bd467","349":"70fa1d79","453":"66b30ced","479":"4671c153","655":"98737334","674":"e74f57b8","768":"5067bf02","813":"98d859f7","963":"5fea5117"}[chunkId] + ".chunk.js";
};